module.exports = __webpack_public_path__ + "static/media/dp.732a34bd.svg";